// import React, { useState, useEffect } from "react";
// import config from '../../utils/Config';

// function WestEdWDC() {
//   const [selectedReport, setSelectedReport] = useState("survey");

//   useEffect(() => {
//     const loadTableauSDK = () => {
//       if (!document.getElementById("tableau-sdk")) {
//         const script = document.createElement("script");
//         script.id = "tableau-sdk";
//         script.src = "/libs/tableauwdc-2.3.0.min.js";
//         script.crossOrigin = "anonymous";
//         script.async = true;
//         script.onload = checkTableauReady;
//         script.onerror = () => console.error("❌ Failed to load Tableau SDK.");
//         document.body.appendChild(script);
//       } else {
//         checkTableauReady();
//       }
//     };

//     const checkTableauReady = () => {
//       let retryCount = 0;
//       const maxRetries = 10;

//       const retryCheck = () => {
//         if (window.tableau && typeof window.tableau.makeConnector === "function") {
//           initializeTableau();
//         } else if (retryCount < maxRetries) {
//           retryCount++;
//           setTimeout(retryCheck, 1000);
//         } else {
//           console.error("❌ Tableau failed to initialize after max retries.");
//         }
//       };

//       retryCheck();
//     };

//     const initializeTableau = () => {
//       const myConnector = window.tableau.makeConnector();

//       myConnector.init = function (initCallback) {
//         const report = JSON.parse(window.tableau.connectionData || '{}').report || "survey";
//         window.tableau.connectionName = `WestEd ${report} Report`;
//         initCallback();
//       };

//       myConnector.getSchema = function (schemaCallback) {
//         const report = JSON.parse(window.tableau.connectionData || '{}').report || "survey";
//         console.log("📊 getSchema for report:", report);

//         let columns = [];

//         if (report === 'survey') {
//           columns = [
//             { id: "NAME", dataType: window.tableau.dataTypeEnum.string },
//             { id: "EMAILID", dataType: window.tableau.dataTypeEnum.string },
//             { id: "COUNTY", dataType: window.tableau.dataTypeEnum.string },
//             { id: "DISTRICT", dataType: window.tableau.dataTypeEnum.string },
//             { id: "SURVEY_TYPE", dataType: window.tableau.dataTypeEnum.string },
//             { id: "SCHOOL_NAME", dataType: window.tableau.dataTypeEnum.string },
//             { id: "SCHOOL_ID", dataType: window.tableau.dataTypeEnum.string },
//             { id: "CLOSEDATABY", dataType: window.tableau.dataTypeEnum.string },
//             { id: "CLOSEDATAAT", dataType: window.tableau.dataTypeEnum.string },
//             { id: "CLOSEDATACTION", dataType: window.tableau.dataTypeEnum.int },
//             { id: "CORE_MODULE", dataType: window.tableau.dataTypeEnum.int },
//             { id: "BEHAVIORAL_HEALTH", dataType: window.tableau.dataTypeEnum.int },
//             { id: "SCHOOL_CLIMATE", dataType: window.tableau.dataTypeEnum.int },
//             { id: "SOCIAL_EMOTIONAL_HEALTH", dataType: window.tableau.dataTypeEnum.int },
//             { id: "WELLNESS", dataType: window.tableau.dataTypeEnum.int },
//             { id: "TRAUMA_INFORMED_PRACTICE", dataType: window.tableau.dataTypeEnum.int },
//             { id: "COMMUNITY_HEALTH", dataType: window.tableau.dataTypeEnum.int },
//             { id: "COMMUNITY_SCHOOLS", dataType: window.tableau.dataTypeEnum.int },
//             { id: "CLOSING_THE_ACHIEVEMENT_GAP", dataType: window.tableau.dataTypeEnum.int },
//             { id: "DRUG_FREE_COMMUNITIES", dataType: window.tableau.dataTypeEnum.int },
//             { id: "LGBTQ_BASED_HARASSMENT", dataType: window.tableau.dataTypeEnum.int },
//             { id: "MENTAL_HEALTH_SUPPORTS", dataType: window.tableau.dataTypeEnum.int },
//             { id: "TUPE", dataType: window.tableau.dataTypeEnum.int },
//             { id: "DISTRICT_AFTER_SCHOOL", dataType: window.tableau.dataTypeEnum.int },
//             { id: "GANG_RISK_AWARENESS", dataType: window.tableau.dataTypeEnum.int },
//             { id: "MILITARY_CONNECTED_SCHOOL", dataType: window.tableau.dataTypeEnum.int },
//             { id: "RESILIENCE_YOUTH_DEVELOPMENT", dataType: window.tableau.dataTypeEnum.int },
//             { id: "SAFETY_VIOLENCE", dataType: window.tableau.dataTypeEnum.int },
//             { id: "SEXUAL_BEHAVIOR", dataType: window.tableau.dataTypeEnum.int },
//             { id: "TOBACCO", dataType: window.tableau.dataTypeEnum.int },
//             { id: "SUPPLEMENTAL_HEALTH", dataType: window.tableau.dataTypeEnum.int },
//             { id: "SPECIAL_EDUCATION_SUPPORTS", dataType: window.tableau.dataTypeEnum.int },
//             { id: "CUSTOM", dataType: window.tableau.dataTypeEnum.int },
//             { id: "BLOCK", dataType: window.tableau.dataTypeEnum.string },
//             { id: "SURVEYREGSUBMITTEDBY", dataType: window.tableau.dataTypeEnum.string },
//             { id: "ROLE", dataType: window.tableau.dataTypeEnum.string },
//             { id: "SURVEYTAKENDATE", dataType: window.tableau.dataTypeEnum.string },
//             { id: "GENDER_IDENTITY_SEXUAL_ORIENTATION_BASED_HARASSMENT", dataType: window.tableau.dataTypeEnum.int },
//             { id: "STUDENT_WELLNESS", dataType: window.tableau.dataTypeEnum.int }
//           ];
//         } else if (report === 'dcu') {
//           columns = [
//             { id: 'COUNTY', dataType: window.tableau.dataTypeEnum.string }, { id: 'DISTRICT', dataType: window.tableau.dataTypeEnum.string }, { id: 'FUNDED', dataType: window.tableau.dataTypeEnum.string }, { id: 'FIRST_NAME', dataType: window.tableau.dataTypeEnum.string }, { id: 'LAST_NAME', dataType: window.tableau.dataTypeEnum.string }, { id: 'EMAILID', dataType: window.tableau.dataTypeEnum.string },
//             { id: 'PHONE', dataType: window.tableau.dataTypeEnum.string }, { id: 'ADDRESS', dataType: window.tableau.dataTypeEnum.string }, { id: 'CITY', dataType: window.tableau.dataTypeEnum.string }, { id: 'ZIP_CODE', dataType: window.tableau.dataTypeEnum.string }, { id: 'CNTYDISTID', dataType: window.tableau.dataTypeEnum.string }, { id: 'CREATEDAT', dataType: window.tableau.dataTypeEnum.string },
//             { id: 'APPROVEAT', dataType: window.tableau.dataTypeEnum.string }, { id: 'APPROVE_STATUS', dataType: window.tableau.dataTypeEnum.string }, { id: 'SUBMIT_STATUS', dataType: window.tableau.dataTypeEnum.string }, { id: 'REPORT_ORDERED', dataType: window.tableau.dataTypeEnum.string }, { id: 'TAKESURVEYDATE', dataType: window.tableau.dataTypeEnum.string }, { id: 'APPROVEACTION', dataType: window.tableau.dataTypeEnum.string },
//             { id: 'APPROVEBY', dataType: window.tableau.dataTypeEnum.string }, { id: 'SURVEYREGSUBMITBY', dataType: window.tableau.dataTypeEnum.string }, { id: 'SURVEYREGSUBMITAT', dataType: window.tableau.dataTypeEnum.string }, { id: 'SURVEYREGSUBMITACTION', dataType: window.tableau.dataTypeEnum.string }, { id: 'ORDERREPORTSUBMITBY', dataType: window.tableau.dataTypeEnum.string }, { id: 'ORDERREPORTSUBMITAT', dataType: window.tableau.dataTypeEnum.string }, { id: 'ORDERREPORTSUBMITACTION', dataType: window.tableau.dataTypeEnum.string }
//         ];
//         }

//         const tableSchema = {
//           id: "WestEdReport",
//           alias: "WestEd Report Data",
//           columns: columns
//         };

//         schemaCallback([tableSchema]);
//       };

//       myConnector.getData = async function (table, doneCallback) {
//         const report = JSON.parse(window.tableau.connectionData || '{}').report || "survey";
//         console.log("📦 getData for report:", report);
//         try {
//           // let url = report === "survey"
//           //   ? `${config.basePath}common/surveyexceltableu`
//           //   : `${config.basePath}coordinator/getDistrictExceltableau`;
//           let url = "";

//           if (report === "survey") {
//             url = `${config.basePath}common/surveyexceltableu`;
//           } else if (report === "dcu") {
//             url = `${config.basePath}coordinator/getDistrictExceltableau`;
//           }
//           const response = await fetch(url);
//           if (!response.ok) throw new Error("Network response was not ok");

//           const data = await response.json();

//           let formattedData = [];

//           if (report === 'survey') {
//             formattedData = data.map((item) => ({
//               NAME: item.NAME || "",
//               EMAILID: item.EMAILID || "",
//               COUNTY: item.COUNTY || "",
//               DISTRICT: item.DISTRICT || "",
//               SURVEY_TYPE: item["SURVEY TYPE"] || "",
//               SCHOOL_NAME: item["SCHOOL NAME"] || "",
//               SCHOOL_ID: item["SCHOOL ID"] || "",
//               CLOSEDATABY: item.closeDataBy || "",
//               CLOSEDATAAT: item.closeDataAt || "",
//               CLOSEDATACTION: item.closeDataction || 0,
//               CORE_MODULE: item["CORE MODULE"] || 0,
//               BEHAVIORAL_HEALTH: item["BEHAVIORAL HEALTH"] || 0,
//               SCHOOL_CLIMATE: item["SCHOOL CLIMATE"] || 0,
//               SOCIAL_EMOTIONAL_HEALTH: item["SOCIAL EMOTIONAL HEALTH"] || 0,
//               WELLNESS: item.WELLNESS || 0,
//               TRAUMA_INFORMED_PRACTICE: item["TRAUMA-INFORMED PRACTICE"] || 0,
//               COMMUNITY_HEALTH: item["COMMUNITY HEALTH"] || 0,
//               COMMUNITY_SCHOOLS: item["COMMUNITY SCHOOLS"] || 0,
//               CLOSING_THE_ACHIEVEMENT_GAP: item["CLOSING THE ACHIEVEMENT GAP"] || 0,
//               DRUG_FREE_COMMUNITIES: item["DRUG-FREE COMMUNITIES"] || 0,
//               LGBTQ_BASED_HARASSMENT: item["LGBTQ-BASED HARASSMENT"] || 0,
//               MENTAL_HEALTH_SUPPORTS: item["MENTAL HEALTH SUPPORTS"] || 0,
//               TUPE: item.TUPE || 0,
//               DISTRICT_AFTER_SCHOOL: item["DISTRICT AFTERSCHOOL"] || 0,
//               GANG_RISK_AWARENESS: item["GANG RISK AWARENESS"] || 0,
//               MILITARY_CONNECTED_SCHOOL: item["MILITARY-CONNECTED SCHOOL"] || 0,
//               RESILIENCE_YOUTH_DEVELOPMENT: item["RESILIENCE & YOUTH DEVELOPMENT"] || 0,
//               SAFETY_VIOLENCE: item["SAFETY & VIOLENCE"] || 0,
//               SEXUAL_BEHAVIOR: item["SEXUAL BEHAVIOR"] || 0,
//               TOBACCO: item.TOBACCO || 0,
//               SUPPLEMENTAL_HEALTH: item["SUPPLEMENTAL HEALTH"] || 0,
//               SPECIAL_EDUCATION_SUPPORTS: item["SPECIAL EDUCATION SUPPORTS"] || 0,
//               CUSTOM: item.CUSTOM || 0,
//               BLOCK: item.BLOCK || "",
//               SURVEYREGSUBMITTEDBY: item.SURVEYREGSUBMITTEDBY || "",
//               ROLE: item.ROLE || "",
//               SURVEYTAKENDATE: item.surveyTakenDate || "",
//               GENDER_IDENTITY_SEXUAL_ORIENTATION_BASED_HARASSMENT: item["GENDER IDENTITY & SEXUAL ORIENTATION-BASED HARASSMENT"] || 0,
//               STUDENT_WELLNESS: item["STUDENT WELLNESS"] || 0
//             }));
//           } else if (report === 'dcu') {
//             formattedData = data.map((item) => ({
//               COUNTY: item.COUNTY || "",
//               DISTRICT: item.DISTRICT || "",
//               FUNDED: item.FUNDED || "",
//               FIRST_NAME: item.FIRST_NAME || "",
//               LAST_NAME: item.LAST_NAME || "",
//               EMAILID: item.EMAILID || "",
//               PHONE: item.PHONE || "",
//               ADDRESS: item.ADDRESS || "",
//               CITY: item.CITY || "",
//               ZIP_CODE: item.ZIP_CODE || "",
//               CNTYDISTID: item.CNTYDISTID || "",
//               CREATEDAT: item.CREATEDAT || "",
//               APPROVEAT: item.APPROVEAT || "",
//               APPROVE_STATUS: item.APPROVE_STATUS || "",
//               SUBMIT_STATUS: item.SUBMIT_STATUS || "",
//               REPORT_ORDERED: item.REPORT_ORDERED || "",
//               TAKESURVEYDATE: item.TAKESURVEYDATE || "",
//               APPROVEACTION: item.APPROVEACTION || "",
//               APPROVEBY: item.APPROVEBY || "",
//               SURVEYREGSUBMITBY: item.SURVEYREGSUBMITBY || "",
//               SURVEYREGSUBMITAT: item.SURVEYREGSUBMITAT || "",
//               SURVEYREGSUBMITACTION: item.SURVEYREGSUBMITACTION || "",
//               ORDERREPORTSUBMITBY: item.ORDERREPORTSUBMITBY || "",
//               ORDERREPORTSUBMITAT: item.ORDERREPORTSUBMITAT || "",
//               ORDERREPORTSUBMITACTION: item.ORDERREPORTSUBMITACTION || ""
//             }));            
//           }

//           table.appendRows(formattedData);
//           doneCallback();
//         } catch (error) {
//           console.error("❌ Error fetching data: ", error);
//         }
//       };

//       window.tableau.registerConnector(myConnector);
//     };

//     loadTableauSDK();
//   }, []);

//   const handleSelectChange = (event) => {
//     setSelectedReport(event.target.value);
//     window.tableau.connectionData = JSON.stringify({ report: event.target.value });
//   };

//   const handleSubmit = () => {
//     // window.tableau.connectionData = JSON.stringify({ report: selectedReport });

//     if (window.tableau && window.tableau.submit) {
//       window.tableau.submit();
//     } else {
//       setTimeout(handleSubmit, 500);
//     }
//   };

//   return (
//     <div className="container d-flex flex-column justify-content-center align-items-center vh-100" style={{ marginTop: "15%", marginLeft: "40%" }}>
//       <h1 className="text-center mb-3">Select a Report Type</h1>
//       <div className="col-md-6" style={{ marginBottom: "3%" }}>
//         <select
//           name="report"
//           id="rpt"
//           className="form-control"
//           style={{ width: "300px", height: "40px", fontSize: "18px", padding: "10px" }}
//           value={selectedReport}
//           onChange={handleSelectChange}
//         >
//           <option value="survey">Survey Report</option>
//           <option value="dcu">District Coordinator</option>
//         </select>
//       </div>
//       <div className="col-md-4 text-center" style={{ marginBottom: "3%", marginLeft: "7%" }}>
//         <button
//           type="button"
//           id="submitButton"
//           className="btn btn-success"
//           style={{
//             backgroundColor: "#28a745",
//             border: "2px solid #28a745",
//             color: "white",
//             padding: "10px 20px",
//             fontSize: "16px",
//             borderRadius: "5px",
//             cursor: "pointer"
//           }}
//           onClick={handleSubmit}
//         >
//           Get WestEd Data
//         </button>
//         <div>{selectedReport}</div>
//       </div>
//     </div>
//   );
// }

// export default WestEdWDC;




import React, { useState, useEffect } from "react";
import { getReportConfig } from "./reportConfigs";

function WestEdWDC() {
  const [selectedReport, setSelectedReport] = useState("survey");

  useEffect(() => {
    const loadTableauSDK = () => {
      if (!document.getElementById("tableau-sdk")) {
        const script = document.createElement("script");
        script.id = "tableau-sdk";
        script.src = "/libs/tableauwdc-2.3.0.min.js";
        script.async = true;
        script.crossOrigin = "anonymous";
        script.onload = checkTableauReady;
        document.body.appendChild(script);
      } else {
        checkTableauReady();
      }
    };

    const checkTableauReady = () => {
      let retryCount = 0;
      const maxRetries = 10;
      const retryCheck = () => {
        if (window.tableau?.makeConnector) {
          initializeTableau();
        } else if (retryCount < maxRetries) {
          retryCount++;
          setTimeout(retryCheck, 1000);
        } else {
          console.error("❌ Tableau SDK failed to load");
        }
      };
      retryCheck();
    };

    const initializeTableau = () => {
      const connector = window.tableau.makeConnector();

      connector.init = (initCallback) => {
        const report = JSON.parse(window.tableau.connectionData || '{}').report || "survey";
        window.tableau.connectionName = `WestEd ${report} Report`;
        initCallback();
      };

      connector.getSchema = (schemaCallback) => {
        const report = JSON.parse(window.tableau.connectionData || '{}').report || "survey";
        const config = getReportConfig(report);
        schemaCallback([{ id: "WestEdReport", alias: "WestEd Report Data", columns: config.columns }]);
      };

      connector.getData = async (table, doneCallback) => {
        const report = JSON.parse(window.tableau.connectionData || '{}').report || "survey";
        const { url, formatData } = getReportConfig(report);
        try {
          // Get Tableau token from query param or localStorage
          let tableauToken = new URLSearchParams(window.location.search).get('token');

          if (!tableauToken) {
            tableauToken = localStorage.getItem('tableau_token');
          }

          if (!tableauToken) {
            throw new Error('No Tableau token found. Please provide token via ?token= parameter');
          }

          const response = await fetch(url, {
            headers: {
              'x-tableau-token': tableauToken
            }
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`API Error: ${response.status} - ${errorData.message || response.statusText}`);
          }

          const data = await response.json();
          const formatted = formatData(data);
          table.appendRows(formatted);
          doneCallback();
        } catch (err) {
          console.error("❌ Error in getData:", err);
          doneCallback();
        }
      };

      window.tableau.registerConnector(connector);
    };

    loadTableauSDK();
  }, []);

  const handleSelectChange = (e) => {
    const value = e.target.value;
    setSelectedReport(value);
    window.tableau.connectionData = JSON.stringify({ report: value });
  };

  const handleSubmit = () => {
    if (window.tableau?.submit) window.tableau.submit();
    else setTimeout(handleSubmit, 500);
  };

  return (
    <div style={{ marginTop: "15%", marginLeft: "40%" }}>
      <h1>Select a Report Type</h1>
      <select value={selectedReport} onChange={handleSelectChange} style={{ width: 300, padding: 10 }}>
        <option value="survey">Survey Report</option>
        <option value="dcu">District Coordinator</option>
      </select>
      <br /><br />
      <button onClick={handleSubmit} className="btn btn-success">
        Get WestEd Data
      </button>
    </div>
  );
}

export default WestEdWDC;

